export default __webpack_public_path__ + "images/leaflet/layers-2x.png";